// Copyright (c) 2016 Deere & Company

export const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams, location} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName: location.pathname,
        routeParams
    };

};



// WEBPACK FOOTER //
// ./src/shared/services/state-connector.js